import { Box, Grid, Skeleton, Typography } from "@mui/material";
import React from "react";
import ReceiptOutlinedIcon from "@mui/icons-material/ReceiptOutlined";
import PlaceOutlinedIcon from "@mui/icons-material/PlaceOutlined";
import GppGoodOutlinedIcon from "@mui/icons-material/GppGoodOutlined";
import NotificationsNoneIcon from "@mui/icons-material/NotificationsNone";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";

const ProductDetailSkeleton = () => {
  return (
    <>
      <Grid
        container
        spacing={2}
        justifyContent={"center"}
        alignItems={"start"}
        width={"100%"}
        height={"100%"}
        position={"relative"}
      >
        <Grid item xs={12} sm={5} md={3} lg={3} xl={3}>
          <Box>
            <Grid container>
              <Grid item width={"100%"}>
                <Skeleton width={"100%"} height={300} />
              </Grid>
              <Grid item width={"100%"}>
                <Skeleton width={"100%"} height={100} />
              </Grid>
            </Grid>
          </Box>
        </Grid>
        <Grid item xs={12} sm={7} md={6} lg={5} xl={6}>
          <Grid container spacing={2} style={{ padding: "0 20px 0 15px" }}>
            <Grid item xs={12} sx={{ display: "flex" }}>
              <Skeleton width={30} /> / <Skeleton width={30} />
            </Grid>
            <Grid item xs={12} style={{ color: "#1D4A87", fontSize: "1.3rem" }}>
              <Skeleton width={200} />
            </Grid>
            <Grid item xs={12} style={{ color: "#BDBDBD" }}>
              <Skeleton width={200} />
            </Grid>
            <Grid item xs={12} sx={{ fontSize: "1.2rem", marginTop: "15px" }}>
              <span className="fontWeight">
                رنگ کالا: <Skeleton width={40} />
              </span>
            </Grid>

            <Grid item xs={6}>
              <div>
                <div
                  className="emptyCircle"
                  tabIndex={1}
                  style={{
                    textAlign: "center",
                    verticalAlign: "top",
                    writingMode: "vertical-rl",
                    alignContent: "center",
                    marginLeft: "10px",
                  }}
                >
                  <Skeleton variant="circular" width={"100%"} height={"100%"} />
                </div>
              </div>
            </Grid>
            <Grid item xs={12}></Grid>
            <b
              style={{ marginTop: "20px", marginBottom: "15px" }}
              className="textFont16"
            >
              مشخصات کالا
            </b>

            <Grid
              item
              xs={12}
              sx={{
                height: "fit-content",
                maxHeight: "55vh",
                overflowY: "auto",
                borderRight: "2px solid #E0E0E0",
                padding: "0px !important",
              }}
              className="costumized-scrollBar"
            >
              <Grid container>
                <Skeleton width={200} />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
          <Grid
            container
            spacing={2}
            style={{
              border: "1px solid #E0E0E0",
              borderRadius: "5px",
              padding: "0 20px 20px 20px ",
              marginBottom: "5px",
              marginTop: "5px",
            }}
            className="colorTitle "
          >
            <Grid
              item
              xs={12}
              style={{
                borderBottom: "1px solid #E0E0E0",
                borderRadius: "5px",
                padding: "4px 0px 0px 0px ",
              }}
              className="paddingGrid"
            >
              <Skeleton width={"100%"} height={30} />
            </Grid>
            <Grid
              item
              xs={12}
              style={{ borderBottom: "1px solid #E0E0E0", padding: "16px 0px 0px 0px ", }}
              className="paddingGrid"
            >
              <Skeleton style={{ marginTop: '-10px' }} width={"100%"} height={30} />
            </Grid>
            <Grid item xs={12}
              style={{ padding: "16px 0px 0px 0px ", }}
            >
              <Skeleton width={"100%"} height={30} />
            </Grid>
            <Grid
              item
              xs={12}
              container
              style={{
                borderBottom: "1px solid #E0E0E0",
              }}
              className="paddingGrid"
            >
              <Grid item xs={2} sx={{ alignItems: "center" }}>
                <Skeleton width={"80%"} height={30} />
              </Grid>
              <Grid item xs={3} style={{ alignItems: "center", marginTop: '-20px' }}>
                <Skeleton width={"100%"} height={60} />
              </Grid>
              <Grid item xs={6} style={{
                alignItems: "center", justifyContent: "left",
                marginRight: '3vh'
              }}>
                <Skeleton width={"100%"} height={30} />
              </Grid>
            </Grid>

            <Grid
              xs={12}
              container
              // spacing={2}
              style={{
                borderBottom: "1px solid #E0E0E0",
                marginTop: "10px",
              }}
              className="paddingGrid"
            >
              <Grid item xs={6}>
                <Skeleton width={"80%"} height={30} />
              </Grid>
              <Grid
                item
                xs={6}
                style={{
                  textAlign: "left",
                  color: "#424242",
                }}
              >
                <Skeleton width={"80%"} height={30} />
              </Grid>
              <br />
              <br />
              <Grid item xs={6}>
                <Skeleton width={"80%"} height={30} />
              </Grid>
              <Grid
                item
                xs={6}
                style={{
                  textAlign: "left",
                  color: "#424242",
                }}
              >
                <Skeleton width={"80%"} height={30} />
              </Grid>
              <br />
              <br />
              <Grid item xs={6}>
                <Skeleton width={"80%"} height={30} />
              </Grid>
              <Grid
                item
                xs={6}
                style={{
                  textAlign: "left",
                  color: "#424242",
                }}
              >
                <Skeleton width={"80%"} height={30} />
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <Skeleton width={"80%"} height={30} />
            </Grid>
            <Grid
              item
              xs={12}
              style={{ textAlign: "left", fontSize: "1.5em" }}
              className="colorOk"
            >
              <Skeleton width={"100%"} height={30} />
            </Grid>
            <Grid item xs={12} >
              <Skeleton width={"100%"} height={70} style={{ marginTop: '60px' }} />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default ProductDetailSkeleton;
